import { gql } from 'graphql-tag'

const weeklyInfoLinkFragment = gql`
  fragment WeeklyInfoLinkFragment on WeeklyInfoLinks {
    id
    fileName
    href
    type
    station {
      id
      name
    }
  }
`

export const addWeeklyInfoLink = gql`
  mutation AddWeeklyInfoLink($stationId: ID, $type: String!, $fileName: String!, $href: String!) {
    createWeeklyInfoLinks(stationId: $stationId, type: $type, fileName: $fileName, href: $href) {
      ...WeeklyInfoLinkFragment
    }
  }
  ${weeklyInfoLinkFragment}
`

export const deleteWeeklyInfoLink = gql`
  mutation DeleteWeeklyInfoLink($id: ID!) {
    deleteWeeklyInfoLinks(id: $id)
  }
`

export const fetchWeeklyInfoLinks = gql`
  query FetchWeeklyInfoLinks($stationId: ID!, $type: String!) {
    weeklyInfoLinks(stationId: $stationId, type: $type) {
      ...WeeklyInfoLinkFragment
    }
  }
  ${weeklyInfoLinkFragment}
`

export const fetchFileLinks = gql`
  query FetchFileLinks($companyId: ID!) {
    fileLinks {
      id
      fileName
      href
    }
    aokFileLinks(companyId: $companyId) {
      id
      fileName
      href
    }
  }
`
